import { call, takeLatest } from "redux-saga/effects";
import {
  INVOICE_VERIFY_DETAIL,
  INVOICE_VERIFY_LIST,
  INVOICE_VERIFIED_LIST,
  AI_VERIFIED_INVOICE_LIST,
  AI_VERIFIED_INVOICE_DETAIL,
  VERIFIED_INVOICE_DETAIL,
  VERIFIED_INVOICE_LIST,
  FLAGGED_INVOICE_LIST,
  FLAGGED_INVOICE_DETAIL,
  PENDING_INVOICE_DETAIL,
  PENDING_INVOICE_LIST,
  REJECTED_INVOICE_LIST,
  REJECTED_INVOICE_DETAIL,
  VERIFY_PENDING_INVOICE_DETAIL,
  REJECT_PENDING_INVOICE_DETAIL,
  PRODUCT_BATCH_PRICING_DROPDOWN,
  UPDATE_PRODUCT_PTR,
  FLAG_AIVERIFIED_INVOICE_DETAIL,
} from "../actions/types";
import {
  invoiceVerifyListApi,
  invoiceVerifyViewApi,
  invoiceVerifiedListApi,
  aiVerifiedInvoiceListApi,
  aiVerifiedInvoiceViewApi,
  verifiedInvoiceListApi,
  verifiedInvoiceViewApi,
  flaggedInvoiceViewApi,
  flaggedInvoiceListApi,
  pendingInvoiceListApi,
  pendingInvoiceViewApi,
  rejectedInvoiceListApi,
  rejectedInvoiceViewApi,
  verifyPendingInvoiceApi,
  rejectPendingInvoiceApi,
  productBatchPricingDropdown,
  updateProductPtrApi,
  flagAiverifiedInvoiceApi,
} from "../apis/invoiceVerificationApi";

export function* invoiceVerifyListWorker(action) {
  try {
    const res = yield call(invoiceVerifyListApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* invoiceVerifiedListWorker(action) {
  try {
    const res = yield call(invoiceVerifiedListApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* aiVerifiedInvoiceListWorker(action) {
  try {
    const res = yield call(aiVerifiedInvoiceListApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* aiVerifiedInvoiceyDetailWorker(action) {
  try {
    const res = yield call(aiVerifiedInvoiceViewApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* verifiedInvoiceListWorker(action) {
  try {
    const res = yield call(verifiedInvoiceListApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* verifiedInvoiceyDetailWorker(action) {
  try {
    const res = yield call(verifiedInvoiceViewApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* flaggedInvoiceListWorker(action) {
  try {
    const res = yield call(flaggedInvoiceListApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* flaggedInvoiceDetailWorker(action) {
  try {
    const res = yield call(flaggedInvoiceViewApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* pendingInvoiceListWorker(action) {
  try {
    const res = yield call(pendingInvoiceListApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* pendingInvoiceDetailWorker(action) {
  try {
    const res = yield call(pendingInvoiceViewApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* rejectedInvoiceListWorker(action) {
  try {
    const res = yield call(rejectedInvoiceListApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* rejectedInvoiceDetailWorker(action) {
  try {
    const res = yield call(rejectedInvoiceViewApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* invoiceVerifyDetailWorker(action) {
  try {
    const res = yield call(invoiceVerifyViewApi, {
      order_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* pendingInvoiceVerifyWorker(action) {
  try {
    const res = yield call(verifyPendingInvoiceApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* pendingInvoiceRejectWorker(action) {
  try {
    const res = yield call(rejectPendingInvoiceApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* upodateProductPtrWorker(action) {
  try {
    const res = yield call(updateProductPtrApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productBatchPricingWorker(action) {
  try {
    const res = yield call(productBatchPricingDropdown, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* flagAiVerifiesInvoicesWorker(action) {
  try {
    const res = yield call(flagAiverifiedInvoiceApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* invoiceVerifyListWatcher() {
  yield takeLatest(INVOICE_VERIFY_LIST, invoiceVerifyListWorker);
}

export function* invoiceVerifiedListWatcher() {
  yield takeLatest(INVOICE_VERIFIED_LIST, invoiceVerifiedListWorker);
}

export function* invoiceVerifyDetailWatcher() {
  yield takeLatest(INVOICE_VERIFY_DETAIL, invoiceVerifyDetailWorker);
}

export function* aiVerifiedInvoiceListWatcher() {
  yield takeLatest(AI_VERIFIED_INVOICE_LIST, aiVerifiedInvoiceListWorker);
}

export function* aiVerifiedInvoiceyDetailWatcher() {
  yield takeLatest(AI_VERIFIED_INVOICE_DETAIL, aiVerifiedInvoiceyDetailWorker);
}

export function* verifiedInvoiceListWatcher() {
  yield takeLatest(VERIFIED_INVOICE_LIST, verifiedInvoiceListWorker);
}

export function* verifiedInvoiceDetailWatcher() {
  yield takeLatest(VERIFIED_INVOICE_DETAIL, verifiedInvoiceyDetailWorker);
}

export function* flaggedInvoiceListWatcher() {
  yield takeLatest(FLAGGED_INVOICE_LIST, flaggedInvoiceListWorker);
}

export function* flaggedInvoiceDetailWatcher() {
  yield takeLatest(FLAGGED_INVOICE_DETAIL, flaggedInvoiceDetailWorker);
}

export function* pendingInvoiceListWatcher() {
  yield takeLatest(PENDING_INVOICE_LIST, pendingInvoiceListWorker);
}

export function* pendingInvoiceDetailWatcher() {
  yield takeLatest(PENDING_INVOICE_DETAIL, pendingInvoiceDetailWorker);
}

export function* rejectedInvoiceListWatcher() {
  yield takeLatest(REJECTED_INVOICE_LIST, rejectedInvoiceListWorker);
}

export function* rejectedInvoiceDetailWatcher() {
  yield takeLatest(REJECTED_INVOICE_DETAIL, rejectedInvoiceDetailWorker);
}
export function* pendingInvoiceVerifyWatcher() {
  yield takeLatest(VERIFY_PENDING_INVOICE_DETAIL, pendingInvoiceVerifyWorker);
}
export function* pendingInvoiceRejectWatcher() {
  yield takeLatest(REJECT_PENDING_INVOICE_DETAIL, pendingInvoiceRejectWorker);
}
export function* productBatchPricingWatcher() {
  yield takeLatest(PRODUCT_BATCH_PRICING_DROPDOWN, productBatchPricingWorker);
}
export function* upodateProductPtrWatcher() {
  yield takeLatest(UPDATE_PRODUCT_PTR, upodateProductPtrWorker);
}
export function* flagAiVerifiesInvoicesWatcher() {
  yield takeLatest(
    FLAG_AIVERIFIED_INVOICE_DETAIL,
    flagAiVerifiesInvoicesWorker
  );
}
